"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapAttributeNameToIcon = void 0;
/* eslint-disable @typescript-eslint/naming-convention */
const iconsDictionary = {
    resort_watersport_ratings: `wassersport`,
    resort_summersport_ratings: `sport`,
    resort_winter_ratings: `wintersport`,
    resort_culture_ratings: `culture`,
    resort_nature_ratings: `natur`,
    resort_entertainment_ratings: `nightlife`,
    resort_flair_ratings: `flair`,
    shopping: `shopping`,
};
/* eslint-enable @typescript-eslint/naming-convention */
const mapAttributeNameToIcon = (featureCode) => {
    return iconsDictionary[featureCode] || 'not-found';
};
exports.mapAttributeNameToIcon = mapAttributeNameToIcon;
//# sourceMappingURL=DestinationAttributes.mappers.js.map